module.exports = __webpack_public_path__ + "static/media/trainVideo14.1db79233.mp4";